import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  const location = useLocation();
return (
    <div>
      <main>
        <Outlet />
        <ToastContainer />
      </main>

    </div>
  );
}

export default App;


